import { Injectable, isDevMode, APP_INITIALIZER, NgModule } from '@angular/core';
import { ofActionSuccessful, InitState, UpdateState, Actions, Store, getStoreMetadata, getValue, setValue, getActionTypeFromInstance, NGXS_PLUGINS } from '@ngxs/store';
import { take } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/internals.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ngxs/store';
function MetaDataModel() { }
if (false) {
    /** @type {?} */
    MetaDataModel.prototype.name;
    /** @type {?} */
    MetaDataModel.prototype.defaults;
    /** @type {?} */
    MetaDataModel.prototype.path;
    /** @type {?|undefined} */
    MetaDataModel.prototype.children;
}
/**
 * a simplified implementation of NGXS StateClass interface
 * @record
 * @template T
 */
function StateClass() { }
if (false) {
    /** @type {?|undefined} */
    StateClass.prototype.NGXS_META;
    /* Skipping unhandled member: new (...args: any[]): T;*/
}
/**
 * @return {?}
 */
function noop() {
    return (/**
     * @return {?}
     */
    () => { });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/reset.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ResetService {
}
ResetService.ɵfac = function ResetService_Factory(t) { return new (t || ResetService)(); };
ResetService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ResetService, factory: ResetService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResetService, [{
        type: Injectable
    }], null, null); })();
if (false) {
    /** @type {?} */
    ResetService.prototype.initialState;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/reset.handler.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ResetHandler {
    /**
     * @param {?} actions$
     * @param {?} store
     * @param {?} resetService
     */
    constructor(actions$, store, resetService) {
        this.actions$ = actions$;
        this.store = store;
        this.resetService = resetService;
        this.actions$
            .pipe(ofActionSuccessful(InitState), take(1))
            .subscribe((/**
         * @return {?}
         */
        () => (this.resetService.initialState = this.store.snapshot())));
        this.actions$.pipe(ofActionSuccessful(UpdateState)).subscribe((/**
         * @param {?} __0
         * @return {?}
         */
        ({ addedStates }) => (this.resetService.initialState = Object.assign(Object.assign({}, this.resetService.initialState), addedStates))));
    }
}
ResetHandler.ɵfac = function ResetHandler_Factory(t) { return new (t || ResetHandler)(ɵngcc0.ɵɵinject(ɵngcc1.Actions), ɵngcc0.ɵɵinject(ɵngcc1.Store), ɵngcc0.ɵɵinject(ResetService)); };
ResetHandler.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ResetHandler, factory: ResetHandler.ɵfac });
/** @nocollapse */
ResetHandler.ctorParameters = () => [
    { type: Actions },
    { type: Store },
    { type: ResetService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResetHandler, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.Actions }, { type: ɵngcc1.Store }, { type: ResetService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    ResetHandler.prototype.actions$;
    /**
     * @type {?}
     * @private
     */
    ResetHandler.prototype.store;
    /**
     * @type {?}
     * @private
     */
    ResetHandler.prototype.resetService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/symbols.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Action to clear all state except given state(s)
 */
class StateClear {
    /**
     * @param {...?} statesToKeep
     */
    constructor(...statesToKeep) {
        /** @type {?} */
        const reducer = createMetaDataListReducer(isDevMode());
        this.statesToKeep = statesToKeep.reduce(reducer, []);
    }
}
StateClear.type = '@@CLEAR_STATE';
if (false) {
    /** @type {?} */
    StateClear.type;
    /** @type {?} */
    StateClear.prototype.statesToKeep;
}
/**
 * Action to reset given state(s) to defaults
 */
class StateReset {
    /**
     * @param {...?} statesToReset
     */
    constructor(...statesToReset) {
        /** @type {?} */
        const reducer = createMetaDataListReducer(isDevMode());
        this.statesToReset = statesToReset.reduce(reducer, []);
    }
}
StateReset.type = '@@RESET_STATE';
if (false) {
    /** @type {?} */
    StateReset.type;
    /** @type {?} */
    StateReset.prototype.statesToReset;
}
/**
 * Action to reset all states expect given state(s) to defaults
 */
class StateResetAll {
    /**
     * @param {...?} statesToKeep
     */
    constructor(...statesToKeep) {
        /** @type {?} */
        const reducer = createMetaDataListReducer(isDevMode());
        this.statesToKeep = statesToKeep.reduce(reducer, []);
    }
}
StateResetAll.type = '@@RESET_STATE_ALL';
if (false) {
    /** @type {?} */
    StateResetAll.type;
    /** @type {?} */
    StateResetAll.prototype.statesToKeep;
}
/**
 * Action to overwrite state(s) with given value(s)
 */
class StateOverwrite {
    /**
     * @param {...?} overwriteConfigs
     */
    constructor(...overwriteConfigs) {
        /** @type {?} */
        const reducer = createMetaTupleReducer(isDevMode());
        const [states, values] = overwriteConfigs.reduce(reducer, [
            [],
            [],
        ]);
        this.statesToOverwrite = states;
        this.values = values;
    }
}
StateOverwrite.type = '@@OVERWRITE_STATE';
if (false) {
    /** @type {?} */
    StateOverwrite.type;
    /** @type {?} */
    StateOverwrite.prototype.statesToOverwrite;
    /** @type {?} */
    StateOverwrite.prototype.values;
}
/**
 * @param {?} state
 * @param {?} devMode
 * @return {?}
 */
function getMetaData(state, devMode) {
    /** @type {?} */
    const meta = (/** @type {?} */ (new Object(getStoreMetadata((/** @type {?} */ (state))))));
    /** @type {?} */
    const isNgxsMeta = meta.name && 'defaults' in meta;
    // Reusability Hack: devMode is number on purpose
    if (!isNgxsMeta && devMode === -2) {
        console.warn(`Reset Plugin Warning: ${meta.name} is not a state class.`);
        return null;
    }
    return meta;
}
/**
 * @param {?} devMode
 * @return {?}
 */
function createMetaDataListReducer(devMode) {
    return (/**
     * @param {?} acc
     * @param {?} state
     * @return {?}
     */
    (acc, state) => {
        // tslint:disable-next-line:no-bitwise
        /** @type {?} */
        const meta = getMetaData(state, ~devMode);
        return meta ? acc.concat(meta) : acc;
    });
}
/**
 * @param {?} devMode
 * @return {?}
 */
function createMetaTupleReducer(devMode) {
    return (/**
     * @param {?} acc
     * @param {?} __1
     * @return {?}
     */
    (acc, [state, value]) => {
        // tslint:disable-next-line:no-bitwise
        /** @type {?} */
        const meta = getMetaData(state, ~devMode);
        return meta ? [acc[0].concat(meta), acc[1].concat(value)] : acc;
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/reset.plugin.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxsResetPlugin {
    /**
     * @param {?} resetService
     */
    constructor(resetService) {
        this.resetService = resetService;
    }
    /**
     * @private
     * @param {?} state
     * @param {?} statesToKeep
     * @return {?}
     */
    clearStates(state, statesToKeep) {
        return statesToKeep.reduce((/**
         * @param {?} obj
         * @param {?} meta
         * @return {?}
         */
        (obj, meta) => {
            /** @type {?} */
            const path = getPath(meta);
            if (!path) {
                return obj;
            }
            /** @type {?} */
            const parts = path.split('.');
            /** @type {?} */
            const value = getValue(state, path);
            return parts.reduceRight((/**
             * @param {?} acc
             * @param {?} part
             * @return {?}
             */
            (acc, part) => part in obj
                ? {
                    [part]: Object.assign(Object.assign({}, obj[part]), acc),
                }
                : { [part]: acc }), value);
        }), {});
    }
    /**
     * @private
     * @param {?} state
     * @param {?} statesToOverwrite
     * @param {?} values
     * @return {?}
     */
    overwriteStates(state, statesToOverwrite, values) {
        statesToOverwrite.forEach((/**
         * @param {?} meta
         * @param {?} index
         * @return {?}
         */
        (meta, index) => {
            /** @type {?} */
            const path = getPath(meta);
            if (!path) {
                return;
            }
            state = setValue(state, path, values[index]);
        }));
        return state;
    }
    /**
     * @private
     * @param {?} state
     * @param {?} statesToReset
     * @return {?}
     */
    resetStates(state, statesToReset) {
        statesToReset.forEach((/**
         * @param {?} meta
         * @return {?}
         */
        (meta) => {
            /** @type {?} */
            const path = getPath(meta);
            if (!path) {
                return;
            }
            state = setValue(state, path, typeof meta.defaults === 'undefined' ? {} : meta.defaults);
            if (meta.children) {
                state = this.resetStates(state, (/** @type {?} */ (meta.children.map(getMetaData))));
            }
        }));
        return state;
    }
    /**
     * @private
     * @param {?} state
     * @param {?} statesToKeep
     * @return {?}
     */
    resetStatesAll(state, statesToKeep) {
        const [metas, values] = statesToKeep.reduce((/**
         * @param {?} acc
         * @param {?} meta
         * @return {?}
         */
        (acc, meta) => {
            /** @type {?} */
            const path = getPath(meta);
            if (!path) {
                return acc;
            }
            acc[0].push(meta);
            acc[1].push(getValue(state, path));
            return acc;
        }), [[], []]);
        return this.overwriteStates(this.resetService.initialState, metas, values);
    }
    /**
     * @param {?} state
     * @param {?} action
     * @param {?} next
     * @return {?}
     */
    handle(state, action, next) {
        /** @type {?} */
        const type = getActionTypeFromInstance(action);
        switch (type) {
            case StateClear.type:
                state = this.clearStates(state, ((/** @type {?} */ (action))).statesToKeep);
                break;
            case StateReset.type:
                state = this.resetStates(state, ((/** @type {?} */ (action))).statesToReset);
                break;
            case StateResetAll.type:
                state = this.resetStatesAll(state, ((/** @type {?} */ (action))).statesToKeep);
                break;
            case StateOverwrite.type:
                const { statesToOverwrite, values } = (/** @type {?} */ (action));
                state = this.overwriteStates(state, statesToOverwrite, values);
                break;
            default:
                break;
        }
        return next(state, action);
    }
}
NgxsResetPlugin.ɵfac = function NgxsResetPlugin_Factory(t) { return new (t || NgxsResetPlugin)(ɵngcc0.ɵɵinject(ResetService)); };
NgxsResetPlugin.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgxsResetPlugin, factory: NgxsResetPlugin.ɵfac });
/** @nocollapse */
NgxsResetPlugin.ctorParameters = () => [
    { type: ResetService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxsResetPlugin, [{
        type: Injectable
    }], function () { return [{ type: ResetService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    NgxsResetPlugin.prototype.resetService;
}
/**
 * @param {?} meta
 * @return {?}
 */
function getPath(meta) {
    return meta.path;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/reset.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxsResetPluginModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: NgxsResetPluginModule,
            providers: [
                ResetService,
                ResetHandler,
                {
                    provide: APP_INITIALIZER,
                    useFactory: noop,
                    deps: [ResetHandler],
                    multi: true,
                },
                {
                    provide: NGXS_PLUGINS,
                    useClass: NgxsResetPlugin,
                    multi: true,
                },
            ],
        };
    }
}
NgxsResetPluginModule.ɵfac = function NgxsResetPluginModule_Factory(t) { return new (t || NgxsResetPluginModule)(); };
NgxsResetPluginModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxsResetPluginModule });
NgxsResetPluginModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxsResetPluginModule, [{
        type: NgModule
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ngxs-reset-plugin.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxsResetPlugin, NgxsResetPluginModule, StateClear, StateOverwrite, StateReset, StateResetAll, getMetaData, ResetService as ɵa, ResetHandler as ɵb, noop as ɵd };

